export { default } from './Renegociacao25DDA';
